module.exports = __webpack_public_path__ + "static/test-video-c7a7ea9c6ce20ea8152cf4b4e7d537f7.mp4";